<div class="video-wrapper">
	<div id="player"></div>
</div>
